import { apiClient } from '@/api/client';
import type { Notification } from '@/types/notification.types';

export const notificationsApi = {
  // Get user notifications
  async getUserNotifications(limit = 50, offset = 0): Promise<Notification[]> {
    const response = await apiClient.get<Notification[]>('/notifications', {
      params: { limit: limit.toString(), offset: offset.toString() },
    });
    return response.data;
  },

  // Get clinic notifications
  async getClinicNotifications(
    limit = 50,
    offset = 0,
  ): Promise<Notification[]> {
    const response = await apiClient.get<Notification[]>(
      `/notifications/clinic`,
      { params: { limit: limit.toString(), offset: offset.toString() } },
    );
    return response.data;
  },

  // Mark notification as read
  async markAsRead(notificationId: number): Promise<Notification> {
    const response = await apiClient.post<Notification>(
      `/notifications/${notificationId}/read`,
    );
    return response.data;
  },

  // Mark all notifications as read
  async markAllAsRead(): Promise<void> {
    await apiClient.post('/notifications/read-all');
  },

  // Delete notification
  async deleteNotification(notificationId: number): Promise<void> {
    await apiClient.delete(`/notifications/${notificationId}`);
  },
};
